import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { MsalService } from '@azure/msal-angular';
import { AboutComponent } from '../about/about.component';
import { Globals } from '../models/globals.model';
import { notification } from '../models/interfaces/notifications';
import { GlobalService } from '../services/global.service';
import { MLService } from '../services/ml-service';
import { NotificationService } from '../services/notification-service';
import { ThemeService } from '../services/theme.service';
import { Tenant } from '../models/tenant.model';
import { TenantService } from '../services/tenant.service';
import { Refinery } from '../models/refinery.model';
import { concatMap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css']
})
export class NavBarComponent implements OnInit {

  userName: string;
  userShortName: string;
  rbacName: string = '';
  countryCode: any;
  countryList: any;
  releaseDetails: any;
  notification: notification[] = [];
  unreadNotifications: number = 0;
  errorNotification = false;
  hideNotificationNumber = false;
  dateString: string;
  notificationLimit = 10;
  tenantList: Tenant[];
  tenantName: string;
  tenantId: number;
  refineryName: string;
  refineryList: string[];
  refinerytMap: Refinery[];
  public destroyed = new Subject<any>();

  constructor(private readonly authService: MsalService, public mlServie: MLService,
    public dialog: MatDialog, public globals: Globals, public globalService: GlobalService,
    private readonly tenantService: TenantService,
    public themeService: ThemeService, public _router: Router, public notificationService: NotificationService) {
    this.countryList = [
      {
        "Id": 1,
        "Name": "English",
        "Code": "EN",
      },
    ];

  }

  ngOnInit() {
    this.themeService.setDarkTheme();
    this.getReleaseDetails();
    this.countryCode = "EN";
    $('#handberg').click(function () {
      $('.row-offcanvas').toggleClass('active');
      $('.collapse').toggleClass('in').toggleClass('hidden-xs').toggleClass('visible-xs');
    });

    $("#close-sidebar").click(function () {
      $(".page-wrapper").removeClass("toggled");
    });
    $("#show-sidebar").click(function () {
      $(".page-wrapper").addClass("toggled");
    });
    this.tenantService.getTenants().subscribe((data: Refinery[]) => {
      let filterData = data.filter(item => item.tenantList[0] != undefined && item.tenantList.length > 0);
      this.refineryList = filterData.map(a => a.refineryName);
      this.refinerytMap = filterData;
      this.populateTenant(this.refineryList[0]);
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next(true);
    this.destroyed.complete();
  }

/**
* binds tenant to dropdown as per refinery slected
*/
populateTenant(refineryName: string) {
  if(this.refinerytMap && this.refinerytMap.length > 0){
    this.refinerytMap.some((u) => {
      if (refineryName === u.refineryName) {
        this.refineryName = refineryName;
        this.tenantList = u.tenantList;
        this.tenantName = this.tenantList[0].tenantName;
        this.onTenantChange(this.tenantList[0]);
      }
    });
  }    
}


  logout() {
    this.authService.logout();
  }

  // show about dialog for version, build date and build number
  openAboutRelease(): void {
   this.dialog.open(AboutComponent, {
        data: this.releaseDetails,
      });
    
  }

  getReleaseDetails() {
    this.releaseDetails = this.globals.releaseDetails;
  }

  selectFlag(Code: any) {
    this.countryCode = Code;
  }

  toggleTheme() {
    if (this.themeService.isDarkTheme()) {
      this.themeService.setLightTheme();
    } else {
      this.themeService.setDarkTheme();
    }
  }

  /**
  * Used for switching tenants and redirection to particular page
  * @param tenant tenant to be updated
  */
  onTenantChange(tenant: Tenant) {
    this.tenantName = tenant.tenantName;
    this.tenantId = tenant.tenantId;
    this.tenantService.setCurrentTenant(tenant);
    
    const currentUrl = this._router.url;
    if (currentUrl) {
      switch (currentUrl.split('/')[1]) {
        case 'modelManagement':
          this._router.navigate(['/']).then(() => {
            this._router.navigate(['modelManagement']);
          });
          break;
        case 'configureModel':
          this._router.navigate(['modelManagement']);
          break;

        default:
          break;
      }
    }
    
  }
}

